(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feature-bar"] && !Shopify.designMode) return;
  try {
    
  class FeatureBarMarquee extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.init();
        });
      });
    }

    init() {
      const tracks = this.querySelectorAll('.feature-bar-track');
      if (tracks.length === 0) return;
      
      // Calculate if we need more duplicates
      const singleTrackWidth = tracks[0].scrollWidth;
      const viewportWidth = window.innerWidth;
      
      // We need at least 2x viewport width for smooth infinite scroll
      const totalContentWidth = singleTrackWidth * tracks.length;
      const requiredWidth = viewportWidth * 2;
      
      // If not enough content, clone tracks until we have enough
      if (totalContentWidth < requiredWidth) {
        const clonesNeeded = Math.ceil(requiredWidth / singleTrackWidth) - tracks.length;
        const firstTrack = tracks[0];
        
        for (let i = 0; i < clonesNeeded; i++) {
          const clone = firstTrack.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          this.appendChild(clone);
        }
      }
      
      // Update animation to scroll exactly one track width
      const newTotalTracks = this.querySelectorAll('.feature-bar-track').length;
      const scrollPercent = 100 / newTotalTracks;
      this.style.setProperty('--scroll-percent', `-${scrollPercent}%`);
    }
  }

  if (!customElements.get('feature-bar-marquee')) {
    customElements.define('feature-bar-marquee', FeatureBarMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
